import { render, staticRenderFns } from "./ListClients.vue?vue&type=template&id=6decad76&scoped=true"
import script from "./ListClients.vue?vue&type=script&lang=js"
export * from "./ListClients.vue?vue&type=script&lang=js"
import style0 from "./ListClients.vue?vue&type=style&index=0&id=6decad76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6decad76",
  null
  
)

export default component.exports